import {Controller} from "@hotwired/stimulus";
import Choices from "choices.js";

export default class extends Controller {
  initialize() {
    this.initChoices();
  }

  initChoices() {
    const element = this.element;
    const defaultOptions = {
      allowHTML: true,
      searchPlaceholderValue: "Search...",
      removeItemButton: true,
      editItems: true,
      searchEnabled: false,
      shouldSort: false,
      itemSelectText: "",
      classNames: {
        containerInner: "form-select",
      },
    };

    // Parse the JSON options from data-select if present
    let userOptions = {};
    if (element.dataset.select) {
      try {
        userOptions = JSON.parse(element.dataset.select);
      } catch (e) {
        console.error("Invalid JSON in data-select attribute:", e);
      }
    }

    // Check for a custom template callback function provided via data-select-template.
    // It is assumed that the attribute references a globally available function.
    const templateFn = element.dataset.selectTemplate;
    let options;
    if (templateFn) {
      options = {
        ...defaultOptions,
        ...userOptions,
        callbackOnCreateTemplates: function (template) {
          return {
            item: ({classNames}, data) => {
              return template(`
                <div class="${classNames.item} ${data.highlighted ? classNames.highlightedState : classNames.itemSelectable
                } ${data.placeholder ? classNames.placeholder : ""}" data-item data-id="${data.id
                }" data-value="${data.value}" ${data.active ? 'aria-selected="true"' : ""
                } ${data.disabled ? 'aria-disabled="true"' : ""} ${data.placeholder ? "data-placeholder" : ""
                }>
                  ${data.placeholder || !data.customProperties?.selected ? data.label : data.customProperties.selected}
                  ${userOptions.removeItemButton === false
                  ? ""
                  : `<button type="button" class="choices__button" aria-label="Remove item" data-button></button>`
                }
                </div>
              `);
            },
            choice: ({classNames}, data) => {
              return template(`
                <div class="${classNames.item} ${classNames.itemChoice} ${data.disabled ? classNames.itemDisabled : classNames.itemSelectable
                } ${data.placeholder ? classNames.placeholder : ""}" data-select-text="${defaultOptions.itemSelectText
                }" data-choice ${data.disabled
                  ? 'data-choice-disabled aria-disabled="true"'
                  : "data-choice-selectable"
                } data-id="${data.id}" data-value="${data.value}" ${data.groupId > 0 ? 'role="treeitem"' : 'role="option"'
                }>
                  <div>
                    ${data.label}
                    ${(() => {
                  let output = "";
                  if (data.customProperties) {
                    for (const key in data.customProperties) {
                      if (
                        Object.prototype.hasOwnProperty.call(data.customProperties, key) &&
                        key !== "selected"
                      ) {
                        output += data.customProperties[key];
                      }
                    }
                  }
                  return output;
                })()}
                  </div>
                </div>
              `);
            },
          };
        },
      };
    } else {
      options = {...defaultOptions, ...userOptions};
    }

    // Initialize Choices on this element
    this.choices = new Choices(element, options);
  }
}
